// src/hooks/useSelectOptions.ts
import { useEffect, useState } from "react";
import { getAuthorized } from "@/lib/fetch";

export type SelectOption = {
  value: string;
  label: string;
};

export function useSelectOptions(base_url?: string) {
  const [options, setOptions] = useState<SelectOption[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!base_url) return;

    let cancelled = false;

    const load = async () => {
      setLoading(true);
      try {
        const url = `${import.meta.env.VITE_BACKEND_URL}/${base_url}`;
        const res = await getAuthorized(url);
        const json = await res.json();

        // IMPORTANT: support { data: [...] } OR [...]
        const rows = Array.isArray(json) ? json : (json?.data ?? []);

        if (!cancelled) {
          setOptions(
            rows.map((r: any) => ({
              value: String(r.id),
              label: r.name, // <-- companies.name
            })),
          );
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [base_url]);

  return { options, loading };
}
